export default __webpack_public_path__ + "static/media/contact_left.f247a8f6.png";